import "./currency.scss";
import * as React from "react";
import { type HTMLProps } from "react";
import { getFormatter } from "../../Utilities/Generic/Numbers";
import NoTranslate from "../NoTranslate";

type Props = HTMLProps<HTMLSpanElement> & ({
    value?: undefined;
    children: number;
} | {
    value: number;
    children?: undefined;
}) & {
    dropDecimalsIfZero?: boolean;
};

export default class Currency extends React.Component<Props> {
    public render(): React.ReactNode {
        // eslint-disable-next-line prefer-const
        let { value, dropDecimalsIfZero, ...props } = this.props;

        // This is used this way in the RevisionPage.tsx
        if(typeof value === "undefined") {
            value = this.props.children;

            if(typeof value === "undefined") {
                value = 0;
            }
        }

        let amount = Math.round(value * 100) / 100;

        // This is to remove (-$0.00)
        if(amount === 0) {
            amount = 0;
        }

        const isZero = amount === Math.floor(amount);

        const formatter = getFormatter("currency");
        let parts = [];

        if(typeof formatter.formatToParts === "undefined") {
            // Safari on iOS <13
            const split = amount.toFixed(2).split(".");

            parts.push({
                type : "currency",
                value: "$",
            }, {
                type : "integer",
                value: split[0],
            }, {
                type : "decimal",
                value: ".",
            }, {
                type : "fraction",
                value: split[1],
            });
        } else {
            parts = formatter.formatToParts(amount);
        }

        const formatted = [];

        for(let i = 0, l = parts.length; i < l; i++) {
            if(
                dropDecimalsIfZero &&
                isZero &&
                [ "fraction", "decimal" ].includes(parts[i].type)
            ) {
                continue;
            }

            if(parts[i].type === "fraction") {
                formatted.push(<span className="cents" key={i}>{parts[i].value}</span>);
                continue;
            }

            formatted.push(parts[i].value);
        }

        return (
            <NoTranslate {...props}>{formatted}</NoTranslate>
        );
    }
}
